.root {
    composes: dark from "../../styles/theming.module.css";
    transition: opacity 0.2s;
    overflow: hidden;
}

.rootMenuInactive {
    opacity: 1;
}

.rootMenuActive {
    opacity: 0;
}

.grid {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    text-align: center;
    padding-block: var(--spacer-8);
}

.inner {
    grid-column: 1 / -1;
}

.link {
    font-size: 14px;
}
